import Vue from 'vue'
import Vuex from 'vuex'
import {mapState} from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
    // 定义状态
    state: {
        author: 'Wise Wrong',
        columnCompetence:false,
        weixinFlag:true,
        shareMsg:{},
        user:{
            name:'',
            img:'',
        },
        getUserFlag:false,
        shareId:0,
        openId:'',
        msgShow_:false,
        codeShowBg:false
    },
    mutations:{
      msgShow(state){
        state.msgShow_=true;
      },
      msgHide(state){
        state.msgShow_ = false;
      },
        newAuthor(state,msg){
            state.author = msg;
        },
        changeCompetence(state,competence){
            state.columnCompetence = competence
        },
        chanegWeixin(state,weixin){
            state.weixinFlag = weixin
        },
        setMsg(state,shares){
            state.shareMsg = shares
        },
        setUser(state,getUser){
            state.user.name = getUser.name
            state.user.img = getUser.img
        },
        changeShareId(state,id){
            state.shareId = id
        },
        setOpenId(state,id){
            state.openId = id
        }
    },
    getters: {
      msgState: state => {
        return state.msgShow_
      }
    }
})

export default store


// WEBPACK FOOTER //
// ./src/vuex/store.js